import { useTlgLink } from './useTlgLink';

export const useLegalUrls = () => {
  return {
    imprintUrl: useTlgLink('/imprint'),
    privacyPolicyUrl: useTlgLink('/privacy-policy'),
    termsAndConditionsUrl: useTlgLink('/terms'),
  };
};
